export const brand = {
  brand1: "98.32% 0.003 254.00",
  brand2: "95.15% 0.010 254.00",
  brand3: "92.00% 0.015 254.00",
  brand4: "89.73% 0.030 254.00",
  brand5: "78.60% 0.060 254.00",
  brand6: "70.38% 0.070 254.00",
  brand7: "62.92% 0.090 254.00",
  brand8: "57.48% 0.100 254.00",
  brand9: "47.61% 0.139 254.45",
  brand10: "43.11% 0.130 254.92",
  brand11: "35.77% 0.110 254.01",
  brand12: "28.40% 0.110 258.96",
};

export const gray = {
  gray1: "99.09% 0.000 0",
  gray2: "98.10% 0.000 0",
  gray3: "95.35% 0.000 0",
  gray4: "92.96% 0.000 89.88",
  gray5: "90.79% 0.000 89.88",
  gray6: "88.38% 0.000 89.88",
  gray7: "85.08% 0.000 89.88",
  gray8: "79.10% 0.000 89.88",
  gray9: "64.35% 0.000 0",
  gray10: "60.85% 0.000 0",
  gray11: "50.31% 0.000 89.88",
  gray12: "24.30% 0.000 89.88",
};

export const mauve = {
  mauve1: "99.18% 0.002 321.13",
  mauve2: "98.32% 0.003 311.22",
  mauve3: "95.56% 0.006 314.24",
  mauve4: "93.16% 0.008 310.01",
  mauve5: "90.90% 0.010 306.61",
  mauve6: "88.60% 0.012 303.95",
  mauve7: "85.36% 0.014 300.59",
  mauve8: "79.36% 0.019 293.52",
  mauve9: "64.58% 0.019 292.62",
  mauve10: "61.06% 0.018 293.07",
  mauve11: "50.48% 0.016 296.08",
  mauve12: "24.46% 0.013 298.05",
};

export const slate = {
  slate1: "99.12% 0.001 286.37",
  slate2: "98.24% 0.003 286.35",
  slate3: "95.57% 0.004 281.88",
  slate4: "93.14% 0.006 282.96",
  slate5: "91.01% 0.008 283.59",
  slate6: "88.76% 0.009 281.79",
  slate7: "85.34% 0.012 280.85",
  slate8: "79.39% 0.016 278.12",
  slate9: "64.56% 0.016 277.83",
  slate10: "60.98% 0.016 273.24",
  slate11: "50.26% 0.014 263.44",
  slate12: "24.13% 0.010 249.52",
};

export const sage = {
  sage1: "99.23% 0.003 160.40",
  sage2: "98.08% 0.003 171.20",
  sage3: "95.50% 0.003 170.38",
  sage4: "93.12% 0.003 170.38",
  sage5: "90.92% 0.004 167.67",
  sage6: "88.51% 0.004 167.67",
  sage7: "85.11% 0.004 169.85",
  sage8: "79.24% 0.005 169.48",
  sage9: "63.93% 0.010 172.38",
  sage10: "60.48% 0.010 172.84",
  sage11: "50.07% 0.008 175.92",
  sage12: "23.98% 0.012 166.78",
};

export const olive = {
  olive1: "99.31% 0.002 149.08",
  olive2: "98.30% 0.003 144.76",
  olive3: "95.61% 0.004 141.14",
  olive4: "93.20% 0.004 142.11",
  olive5: "90.95% 0.005 139.33",
  olive6: "88.55% 0.006 141.14",
  olive7: "85.17% 0.006 141.14",
  olive8: "79.21% 0.007 140.55",
  olive9: "64.04% 0.011 136.53",
  olive10: "60.54% 0.012 136.54",
  olive11: "50.01% 0.011 139.89",
  olive12: "24.19% 0.011 138.23",
};

export const sand = {
  sand1: "99.37% 0.001 106.42",
  sand2: "98.22% 0.001 106.43",
  sand3: "95.55% 0.002 97.61",
  sand4: "93.22% 0.003 100.56",
  sand5: "90.99% 0.004 95.91",
  sand6: "88.55% 0.005 98.34",
  sand7: "85.25% 0.006 96.60",
  sand8: "79.18% 0.008 96.50",
  sand9: "64.13% 0.010 106.69",
  sand10: "60.57% 0.010 106.68",
  sand11: "49.79% 0.008 106.68",
  sand12: "24.34% 0.008 96.31",
};

export const tomato = {
  tomato1: "99.35% 0.003 22.75",
  tomato2: "98.42% 0.007 31.02",
  tomato3: "95.44% 0.022 30.88",
  tomato4: "92.60% 0.047 31.76",
  tomato5: "89.21% 0.063 31.49",
  tomato6: "85.24% 0.077 32.01",
  tomato7: "80.28% 0.094 32.17",
  tomato8: "74.15% 0.118 32.07",
  tomato9: "62.70% 0.194 33.31",
  tomato10: "60.40% 0.195 33.26",
  tomato11: "56.65% 0.198 32.81",
  tomato12: "34.61% 0.080 30.53",
};

export const red = {
  red1: "99.35% 0.003 22.75",
  red2: "98.32% 0.008 16.03",
  red3: "95.61% 0.021 16.23",
  red4: "92.81% 0.047 16.68",
  red5: "89.61% 0.062 17.33",
  red6: "85.70% 0.075 17.87",
  red7: "80.72% 0.089 18.44",
  red8: "74.50% 0.113 19.09",
  red9: "62.54% 0.193 22.98",
  red10: "59.99% 0.195 23.89",
  red11: "55.72% 0.198 25.13",
  red12: "33.91% 0.109 16.68",
};

export const ruby = {
  ruby1: "99.38% 0.003 356.31",
  ruby2: "98.34% 0.008 8.41",
  ruby3: "95.36% 0.022 8.56",
  ruby4: "92.80% 0.042 8.46",
  ruby5: "89.64% 0.055 8.16",
  ruby6: "85.81% 0.066 7.84",
  ruby7: "81.01% 0.080 7.49",
  ruby8: "74.88% 0.101 6.86",
  ruby9: "62.84% 0.195 13.19",
  ruby10: "60.13% 0.196 13.39",
  ruby11: "54.89% 0.199 13.92",
  ruby12: "34.12% 0.110 10.04",
};

export const crimson = {
  crimson1: "99.38% 0.003 356.31",
  crimson2: "98.18% 0.008 357.23",
  crimson3: "95.41% 0.026 356.27",
  crimson4: "92.52% 0.041 356.30",
  crimson5: "89.28% 0.054 355.77",
  crimson6: "85.50% 0.065 355.57",
  crimson7: "80.78% 0.078 354.80",
  crimson8: "75.00% 0.099 354.12",
  crimson9: "63.43% 0.213 1.30",
  crimson10: "60.80% 0.211 2.36",
  crimson11: "55.21% 0.207 4.49",
  crimson12: "34.08% 0.113 356.83",
};

export const pink = {
  pink1: "99.41% 0.004 336.25",
  pink2: "98.31% 0.009 339.97",
  pink3: "95.43% 0.027 340.64",
  pink4: "92.51% 0.042 340.66",
  pink5: "89.31% 0.054 340.86",
  pink6: "85.54% 0.067 340.90",
  pink7: "80.91% 0.083 341.21",
  pink8: "75.17% 0.107 341.63",
  pink9: "61.67% 0.208 346.05",
  pink10: "59.57% 0.207 346.50",
  pink11: "55.66% 0.206 347.33",
  pink12: "35.00% 0.129 345.45",
};

export const plum = {
  plum1: "99.33% 0.005 316.87",
  plum2: "98.31% 0.009 325.99",
  plum3: "95.69% 0.027 325.49",
  plum4: "92.92% 0.044 324.87",
  plum5: "89.85% 0.057 324.37",
  plum6: "86.03% 0.072 323.91",
  plum7: "80.92% 0.091 323.15",
  plum8: "74.18% 0.120 321.88",
  plum9: "57.89% 0.188 322.09",
  plum10: "55.27% 0.181 322.10",
  plum11: "52.13% 0.173 322.02",
  plum12: "33.76% 0.125 321.41",
};

export const purple = {
  purple1: "99.30% 0.004 325.35",
  purple2: "98.23% 0.009 313.12",
  purple3: "95.91% 0.024 313.27",
  purple4: "93.28% 0.039 312.06",
  purple5: "90.07% 0.054 311.57",
  purple6: "85.96% 0.071 311.03",
  purple7: "80.40% 0.093 309.93",
  purple8: "73.31% 0.123 307.97",
  purple9: "55.55% 0.183 305.88",
  purple10: "52.42% 0.176 305.69",
  purple11: "51.60% 0.174 305.70",
  purple12: "32.23% 0.110 303.80",
};

export const violet = {
  violet1: "99.21% 0.003 308.03",
  violet2: "98.30% 0.009 295.04",
  violet3: "96.28% 0.019 296.58",
  violet4: "93.40% 0.039 295.38",
  violet5: "90.39% 0.057 294.12",
  violet6: "86.41% 0.072 293.86",
  violet7: "80.65% 0.090 293.47",
  violet8: "72.91% 0.119 292.43",
  violet9: "54.18% 0.179 288.10",
  violet10: "51.07% 0.177 287.64",
  violet11: "50.80% 0.159 288.59",
  violet12: "31.27% 0.098 286.76",
};

export const iris = {
  iris1: "99.45% 0.003 286.35",
  iris2: "98.12% 0.009 284.10",
  iris3: "96.14% 0.018 283.80",
  iris4: "93.51% 0.035 283.44",
  iris5: "90.45% 0.053 283.77",
  iris6: "86.46% 0.070 283.11",
  iris7: "80.79% 0.088 282.85",
  iris8: "72.92% 0.118 281.48",
  iris9: "54.03% 0.184 278.30",
  iris10: "50.86% 0.186 277.49",
  iris11: "51.04% 0.173 279.69",
  iris12: "31.45% 0.099 277.36",
};

export const indigo = {
  indigo1: "99.42% 0.001 286.37",
  indigo2: "98.29% 0.008 271.38",
  indigo3: "96.07% 0.017 268.55",
  indigo4: "93.53% 0.034 268.49",
  indigo5: "90.32% 0.051 269.98",
  indigo6: "86.30% 0.071 271.51",
  indigo7: "80.68% 0.087 271.37",
  indigo8: "73.01% 0.113 270.52",
  indigo9: "54.36% 0.191 267.08",
  indigo10: "51.12% 0.195 266.48",
  indigo11: "50.97% 0.173 267.11",
  indigo12: "31.26% 0.086 268.56",
};

export const blue = {
  blue1: "99.32% 0.003 247.64",
  blue2: "98.15% 0.010 243.26",
  blue3: "96.00% 0.020 236.71",
  blue4: "93.73% 0.037 239.03",
  blue5: "90.60% 0.053 242.80",
  blue6: "86.38% 0.069 243.18",
  blue7: "80.92% 0.088 243.34",
  blue8: "73.48% 0.121 243.00",
  blue9: "64.93% 0.193 251.81",
  blue10: "62.11% 0.184 251.92",
  blue11: "55.77% 0.189 253.01",
  blue12: "32.40% 0.097 258.96",
};

export const cyan = {
  cyan1: "99.21% 0.004 219.25",
  cyan2: "98.03% 0.009 202.89",
  cyan3: "95.81% 0.026 203.61",
  cyan4: "93.19% 0.041 204.74",
  cyan5: "89.98% 0.054 206.49",
  cyan6: "85.93% 0.066 207.67",
  cyan7: "80.45% 0.082 209.58",
  cyan8: "72.70% 0.110 211.67",
  cyan9: "66.09% 0.122 221.49",
  cyan10: "62.67% 0.114 221.32",
  cyan11: "54.03% 0.127 223.72",
  cyan12: "33.17% 0.053 218.57",
};

export const teal = {
  teal1: "99.39% 0.005 177.55",
  teal2: "98.12% 0.009 179.00",
  teal3: "96.06% 0.027 180.32",
  teal4: "93.46% 0.042 180.22",
  teal5: "90.04% 0.054 180.50",
  teal6: "85.58% 0.064 181.42",
  teal7: "79.74% 0.076 182.21",
  teal8: "72.11% 0.097 183.46",
  teal9: "64.88% 0.113 182.01",
  teal10: "61.95% 0.110 181.20",
  teal11: "52.96% 0.124 179.04",
  teal12: "32.69% 0.050 185.02",
};

export const jade = {
  jade1: "99.45% 0.004 172.63",
  jade2: "98.15% 0.009 160.30",
  jade3: "95.96% 0.022 161.88",
  jade4: "93.39% 0.034 163.54",
  jade5: "90.19% 0.046 164.78",
  jade6: "85.92% 0.059 166.88",
  jade7: "80.03% 0.077 169.53",
  jade8: "72.09% 0.103 173.37",
  jade9: "64.21% 0.115 170.85",
  jade10: "61.34% 0.110 170.61",
  jade11: "52.89% 0.127 167.17",
  jade12: "32.57% 0.041 169.78",
};

export const green = {
  green1: "99.43% 0.004 159.05",
  green2: "98.16% 0.009 155.31",
  green3: "95.88% 0.023 156.38",
  green4: "93.25% 0.036 156.60",
  green5: "89.95% 0.050 157.22",
  green6: "85.70% 0.065 157.89",
  green7: "79.77% 0.084 159.02",
  green8: "71.44% 0.112 160.60",
  green9: "64.05% 0.133 157.75",
  green10: "61.12% 0.126 158.31",
  green11: "52.90% 0.133 158.33",
  green12: "32.18% 0.047 164.62",
};

export const grass = {
  grass1: "99.40% 0.005 146.39",
  grass2: "98.20% 0.009 145.93",
  grass3: "96.08% 0.023 145.27",
  grass4: "93.42% 0.037 146.18",
  grass5: "90.13% 0.053 146.35",
  grass6: "85.78% 0.071 146.83",
  grass7: "79.85% 0.095 147.47",
  grass8: "71.65% 0.130 148.35",
  grass9: "65.16% 0.147 147.37",
  grass10: "61.38% 0.142 147.32",
  grass11: "52.68% 0.130 147.18",
  grass12: "32.68% 0.053 148.58",
};

export const brown = {
  brown1: "99.43% 0.002 63.24",
  brown2: "98.32% 0.006 65.73",
  brown3: "95.41% 0.013 67.82",
  brown4: "92.61% 0.020 66.85",
  brown5: "89.69% 0.029 65.79",
  brown6: "86.24% 0.039 65.47",
  brown7: "81.53% 0.053 64.22",
  brown8: "74.67% 0.072 62.45",
  brown9: "63.27% 0.078 60.77",
  brown10: "59.67% 0.072 59.28",
  brown11: "51.21% 0.058 55.46",
  brown12: "33.15% 0.018 46.98",
};

export const bronze = {
  bronze1: "99.15% 0.001 15.92",
  bronze2: "98.06% 0.007 42.99",
  bronze3: "95.28% 0.010 44.26",
  bronze4: "92.52% 0.014 43.57",
  bronze5: "89.54% 0.018 42.64",
  bronze6: "85.99% 0.023 43.40",
  bronze7: "81.13% 0.030 41.94",
  bronze8: "74.18% 0.039 41.18",
  bronze9: "62.75% 0.046 44.29",
  bronze10: "58.80% 0.045 42.44",
  bronze11: "51.05% 0.044 38.37",
  bronze12: "32.92% 0.029 35.24",
};

export const gold = {
  gold1: "99.37% 0.001 106.42",
  gold2: "98.09% 0.009 97.33",
  gold3: "95.34% 0.012 94.69",
  gold4: "92.57% 0.015 93.18",
  gold5: "89.58% 0.019 90.73",
  gold6: "85.96% 0.025 88.38",
  gold7: "81.01% 0.032 83.41",
  gold8: "73.86% 0.042 78.17",
  gold9: "62.06% 0.049 78.13",
  gold10: "58.77% 0.047 77.42",
  gold11: "50.39% 0.039 78.10",
  gold12: "33.21% 0.019 81.67",
};

export const sky = {
  sky1: "99.33% 0.005 211.91",
  sky2: "97.99% 0.010 217.67",
  sky3: "96.06% 0.024 219.58",
  sky4: "93.56% 0.036 220.39",
  sky5: "90.28% 0.047 221.37",
  sky6: "86.10% 0.058 222.87",
  sky7: "80.58% 0.072 225.65",
  sky8: "72.94% 0.096 227.98",
  sky9: "86.14% 0.103 217.81",
  sky10: "83.77% 0.104 219.57",
  sky11: "52.56% 0.108 232.54",
  sky12: "35.11% 0.057 241.61",
};

export const mint = {
  mint1: "99.28% 0.005 183.68",
  mint2: "98.20% 0.010 178.66",
  mint3: "95.95% 0.030 179.57",
  mint4: "93.30% 0.047 178.98",
  mint5: "89.94% 0.061 178.72",
  mint6: "85.59% 0.072 178.68",
  mint7: "79.79% 0.085 178.22",
  mint8: "72.20% 0.107 177.69",
  mint9: "86.96% 0.100 177.97",
  mint10: "84.12% 0.100 177.77",
  mint11: "51.18% 0.095 176.02",
  mint12: "34.97% 0.051 181.44",
};

export const lime = {
  lime1: "99.24% 0.004 120.67",
  lime2: "98.17% 0.010 116.70",
  lime3: "95.94% 0.043 119.10",
  lime4: "93.21% 0.069 120.38",
  lime5: "89.74% 0.087 121.84",
  lime6: "85.30% 0.099 123.38",
  lime7: "79.46% 0.111 125.31",
  lime8: "72.36% 0.135 128.06",
  lime9: "88.75% 0.175 126.09",
  lime10: "85.89% 0.188 126.73",
  lime11: "54.38% 0.111 128.63",
  lime12: "35.37% 0.057 121.18",
};

export const yellow = {
  yellow1: "99.28% 0.005 106.49",
  yellow2: "98.84% 0.025 102.92",
  yellow3: "97.40% 0.084 104.36",
  yellow4: "95.27% 0.117 101.74",
  yellow5: "92.51% 0.141 98.20",
  yellow6: "88.09% 0.134 95.42",
  yellow7: "83.55% 0.120 92.79",
  yellow8: "76.61% 0.137 89.85",
  yellow9: "92.66% 0.209 102.14",
  yellow10: "89.67% 0.185 97.53",
  yellow11: "57.44% 0.136 81.69",
  yellow12: "35.78% 0.046 86.63",
};

export const amber = {
  amber1: "99.40% 0.003 84.62",
  amber2: "98.62% 0.024 100.26",
  amber3: "96.90% 0.069 100.36",
  amber4: "94.54% 0.104 98.19",
  amber5: "91.84% 0.133 98.40",
  amber6: "88.12% 0.124 93.24",
  amber7: "82.74% 0.122 86.18",
  amber8: "75.82% 0.140 76.70",
  amber9: "85.62% 0.178 81.37",
  amber10: "83.15% 0.168 80.94",
  amber11: "56.92% 0.144 67.28",
  amber12: "35.19% 0.049 53.74",
};

export const orange = {
  orange1: "99.22% 0.003 40.73",
  orange2: "97.87% 0.015 70.83",
  orange3: "95.76% 0.037 78.11",
  orange4: "92.03% 0.081 74.16",
  orange5: "89.04% 0.107 70.84",
  orange6: "85.73% 0.110 64.43",
  orange7: "80.53% 0.113 59.88",
  orange8: "74.54% 0.132 54.82",
  orange9: "68.90% 0.191 44.80",
  orange10: "66.22% 0.194 43.49",
  orange11: "59.19% 0.186 46.95",
  orange12: "35.01% 0.069 40.82",
};
